import React, {useEffect, useState, useContext} from 'react';
import {DashboardGrid} from "../Components/Layout/Containers/GridContainer.react";
import ReportOverview from "../Components/Dashboard/ReportOverview.react";
import ReportDetails from "../Components/Dashboard/ReportDetails.react";
import {useAuth0} from "@auth0/auth0-react";
import useFetch from "../Utilities/API/useFetch.react";
import Reports from "../Components/Dashboard/Reports.react";
import AppContext from "../Context/AppContext.react";
import {StyledForeground} from "../Components/Commons/StyledForeground.react";
import ReportsNew from "../Components/Dashboard/ReportsNew.react";


const Dashboard = () => {
  const {permissions} = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [reports, setReports] = useState([]);
  const [newCustomers, setNewCustomers] = useState();
  const [transactions, setTransactions] = useState();
  const {isLoading, isAuthenticated, user} = useAuth0();
  const [fetchUrl] = useFetch();

  const showCustomReports = permissions.includes('special::all')
  const showReports = permissions.includes('report:view')

  const fetchHeaderData = (newUsersId, totalTransactionsId) => {
    fetchUrl("runSavedReport", {reportId: newUsersId}).then((userReport) => {
      let newUsers = userReport.data == 'undefined' ? userReport.data[0].new_users_count : 0
      setNewCustomers(newUsers);
    })
    fetchUrl("runSavedReport", {reportId: totalTransactionsId}).then((transactionReport) => {
      let totalTransactions = transactionReport.data == 'undefined' ? transactionReport.data[0].total_transactions : 0;
      setTransactions(totalTransactions);
    })
  }

  const fetchReportData = async () => {
    let reportsResponse = await fetchUrl('fetchReports');
    setReports(reportsResponse);
    let newUsers = reportsResponse.find((report) => report.name.includes('New Users'));
    let totalTransactions = reportsResponse.find((report) => report.name.includes('Total Transactions'));
    fetchHeaderData(newUsers?.id, totalTransactions?.id)
    setLoading(false);
  }

  useEffect(() => {
    if (user && !isLoading) {
      fetchReportData()
    }
  }, [user, isLoading])

  return (
    <DashboardGrid gridRows={'13.6rem 55rem 1fr'} headerColor={'transparent'} topColor={'transparent'} bottomColor={'#EEEEEF'}>
      <StyledForeground foreGroundHeight={'80.5rem'}/>
      <div className={'grid-header'}>
        <ReportDetails />
      </div>
      <div className={'grid-top'}>
        <ReportOverview loading={loading} customers={newCustomers} transactions={transactions} />
      </div>
      <div className={'grid-bottom'}>
        <ReportsNew />
      </div>
    </DashboardGrid>
  )
}

export default Dashboard;
